import Logo from "../images/logo.png";

const VisionIcon = () => (
  <svg
    id="fi_4264841"
    enableBackground="new 0 0 512 512"
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
    className="w-14 h-14 text-teal-700 fill-current"
  >
    <g>
      <path d="m306 316c0-27.57-22.43-50-50-50s-50 22.43-50 50 22.43 50 50 50 50-22.43 50-50z"></path>
      <path d="m2.505 309.379c-3.34 3.782-3.34 9.459 0 13.241 1.116 1.263 27.84 31.286 72.361 61.642 53.424 36.426 116.485 61.738 181.134 61.738 64.658 0 127.719-25.318 181.133-61.738 44.521-30.355 71.246-60.378 72.361-61.642 3.34-3.782 3.34-9.459 0-13.241-1.116-1.263-27.84-31.286-72.361-61.642-53.424-36.425-116.484-61.737-181.133-61.737-64.658 0-127.719 25.318-181.133 61.738-44.522 30.355-71.246 60.378-72.362 61.641zm143.495 6.621c0-60.931 49.627-110 110-110 60.463 0 110 49.165 110 110 0 60.931-49.627 110-110 110-60.463 0-110-49.165-110-110zm279.423-52.04c30.496 20.736 52.605 41.702 62.798 52.044-10.121 10.279-32.009 31.043-62.354 51.733-20.774 14.164-47.836 29.776-79.142 41.272 24.213-23.624 39.275-56.588 39.275-93.009 0-36.422-15.062-69.387-39.277-93.012 31.122 11.428 58.029 26.917 78.7 40.972zm-260.148-40.97c-24.213 23.624-39.275 56.589-39.275 93.01 0 36.422 15.062 69.387 39.277 93.012-31.123-11.428-58.03-26.917-78.7-40.972-30.493-20.734-52.603-41.7-62.798-52.044 10.121-10.279 32.009-31.043 62.354-51.733 20.775-14.165 47.837-29.777 79.142-41.273z"></path>
      <path d="m171 168.775c4.783-2.761 6.422-8.877 3.66-13.66l-30-51.961c-2.761-4.784-8.878-6.422-13.66-3.66-4.783 2.761-6.422 8.877-3.66 13.66l30 51.961c2.774 4.807 8.899 6.409 13.66 3.66z"></path>
      <path d="m381 99.494c-4.782-2.762-10.899-1.123-13.66 3.66l-30 51.961c-2.762 4.783-1.123 10.899 3.66 13.66 4.762 2.749 10.887 1.144 13.66-3.66l30-51.961c2.762-4.783 1.123-10.899-3.66-13.66z"></path>
      <path d="m266 136v-60c0-5.523-4.477-10-10-10s-10 4.477-10 10v60c0 5.523 4.477 10 10 10s10-4.477 10-10z"></path>
    </g>
  </svg>
);

const MissionIcon = () => (
  <svg
    id="fi_3233474"
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
    className="w-14 h-14"
  >
    <g>
      <circle cx="236.056" cy="275.944" fill="#0f766e" r="236.056"></circle> 
      <circle cx="236.057" cy="275.944" fill="#e5e5e5" r="171.169"></circle> 
      <circle cx="236.057" cy="275.944" fill="#0f766e" r="106.281"></circle> 
      <circle cx="236.057" cy="275.944" fill="#2d2d2d" r="41.394"></circle> 
      <path
        d="m236.056 39.887c-6.886 0-13.698.312-20.434.89 120.8 10.361 215.622 111.682 215.622 235.166s-94.822 224.806-215.622 235.167c6.736.578 13.548.89 20.434.89 130.37 0 236.056-105.686 236.056-236.056s-105.685-236.057-236.056-236.057z"
        fill="#0d665e"
      ></path>
      <g>
        <path
          d="m454.893 1.077-51.785 51.785c-2.226 2.226-3.388 5.3-3.19 8.441l2.999 47.781 61.011-61.011-2.802-44.64c-.197-3.142-4.007-4.582-6.233-2.356z"
          fill="#0f766e"
        ></path>
        <path
          d="m510.924 57.107-51.785 51.785c-2.226 2.226-5.3 3.388-8.441 3.19l-47.781-2.999 61.011-61.011 44.64 2.802c3.141.197 4.581 4.008 2.356 6.233z"
          fill="#0f766e"
        ></path>
        <path
          d="m236.056 283.667c-1.976 0-3.953-.754-5.462-2.262-3.016-3.016-3.016-7.907 0-10.923l257.957-257.956c3.017-3.016 7.907-3.016 10.924 0 3.016 3.016 3.016 7.907 0 10.923l-257.957 257.956c-1.508 1.508-3.486 2.262-5.462 2.262z"
          fill="#bfbfbf"
        ></path>
      </g>
    </g>
  </svg>
);
const ValuesIcon = () => (
  <svg
    id="fi_14718735"
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
    className="w-14 h-14"
  >
    <g>
      <path d="m161.524 0 28.099 51.377 51.377 28.099-51.377 28.099-28.099 51.377-28.099-51.377-51.377-28.099 51.377-28.099z" fill="#0f766e"></path>
      <path d="m350.476 0 28.099 51.377 51.377 28.099-51.377 28.099-28.099 51.377-28.099-51.377-51.377-28.099 51.377-28.099z" fill="#0d665e"></path>
      <g>
        <path d="m193.59 453.9-30.899 58.1h-70.367v-38.943l-92.324-144.758v-239.85h18.144c27.034 0 48.949 22.079 48.949 49.311v142.851z" fill="#0f766e"></path>
        <path d="m232.447 404.499v107.501h-69.756v-65.905l-92.946-148.13c-8.589-15.569-3.165-35.485 11.875-44.533 15.947-9.587 36.608-3.976 45.602 12.388l43.862 79.759c32.653-.03 61.363 24.78 61.363 58.92z" fill="#0d665e"></path>
      </g>
      <g>
        <path d="m317.515 453.9 31.042 58.1h70.693v-38.943l92.75-144.758v-239.85h-18.227c-27.159 0-49.176 22.079-49.176 49.311v142.851z" fill="#0f766e"></path>
        <path d="m278.478 404.499v107.501h70.078v-63.863l93.375-150.172c8.628-15.569 3.18-35.485-11.93-44.533-16.02-9.587-36.778-3.976-45.813 12.388l-44.064 79.759c-32.803-.03-61.646 24.78-61.646 58.92z" fill="#0d665e"></path>
      </g>
      <path d="m284.099 198.292-28.099-51.377-17.213 79.476 17.213 79.475 28.099-51.376 51.377-28.099z" fill="#0f766e"></path>
      <path d="m227.901 198.292-51.377 28.099 51.377 28.099 28.099 51.376v-158.951z" fill="#0d665e"></path>
    </g>
  </svg>
);


const Vision = () => {
  return (
    <section id="vision" className="bg-white w-full relative">
      <div className="flex flex-col lg:flex-row bg-gradient-to-r from-teal-900 to-green-600 shadow-lg overflow-hidden py-8 min-h-[500px] relative">
        
        {/* Background Logo */}
        <img
          src={Logo}
          alt="Company Logo"
          className="absolute right-0 top-1/2 transform -translate-y-1/2 opacity-10 
                     w-[200px] sm:w-[350px] md:w-[500px] lg:w-[700px] xl:w-[900px] object-contain
                     -mr-[50px] sm:-mr-[100px] md:-mr-[150px] lg:-mr-[200px]"
        />

        <div className="w-full lg:w-3/4 p-6 md:p-12 lg:p-16 flex flex-col justify-center relative z-10">
          
          {/* Vision Section */}
          <div className="mb-12 flex items-center">
            <div className="relative">
              <div className="w-24 h-24 flex items-center justify-center bg-white rounded-full border-8 border-teal-700 shadow-lg">
                <VisionIcon />
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-md px-8 py-3 -ml-6 flex items-center">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
                Our <span className="text-green-700">Vision</span>
              </h2>
            </div>
          </div>

          <ul className="space-y-4 text-white text-lg md:text-xl lg:text-2xl pl-5 list-disc ml-4 text-justify">
            <li className="pl-2">
              To become the "go-to" trading company for customers, suppliers, investors, and employees alike.
            </li>
            <li className="pl-2">
              To ensure our company name and culture are recognized as hallmarks of reliability, innovation, and exceptional customer satisfaction.
            </li>
          </ul>

          {/* Mission Section */}
          <div className="mb-12 flex items-center mt-16">
            <div className="relative">
              <div className="w-24 h-24 flex items-center justify-center bg-white rounded-full border-8 border-teal-700 shadow-lg">
                <MissionIcon />
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-md px-8 py-3 -ml-6 flex items-center">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
                Our <span className="text-green-700">Mission</span>
              </h2>
            </div>
          </div>

          <ul className="space-y-4 text-white text-lg md:text-xl lg:text-2xl pl-5 list-disc ml-4 text-justify">
            <li className="pl-2">
              To continuously satisfy our clients' demands with efficacy, honesty, and loyalty.
            </li>
            <li className="pl-2">
              To streamline the grain supply chain by utilizing innovation and technology.
            </li>
            <li className="pl-2">
              To encourage moral and environmentally friendly behaviour in the grain trade sector.
            </li>
          </ul>

          {/* Core Values Section */}
          <div className="mb-12 flex items-center mt-16">
            <div className="relative">
              <div className="w-24 h-24 flex items-center justify-center bg-white rounded-full border-8 border-teal-700 shadow-lg">
                <ValuesIcon />
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-md px-8 py-3 -ml-6 flex items-center">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
                Our <span className="text-green-700">Core Values</span>
              </h2>
            </div>
          </div>

          <div className="space-y-6 text-white text-lg md:text-xl lg:text-2xl pl-5 ml-4 text-justify">
            <div className="space-y-2">
              <h3 className="font-bold text-2xl md:text-2xl text-white">Integrity:</h3>
              <p>Conducting business with transparency and honesty.</p>
            </div>

            <div className="space-y-2">
              <h3 className="font-bold text-2xl md:text-3xl text-white">Quality:</h3>
              <p>Delivering superior products that meet international standards.</p>
            </div>

            <div className="space-y-2">
              <h3 className="font-bold text-2xl md:text-2xl text-white">Sustainability:</h3>
              <p>Advocating for environmentally responsible and sustainable farming practices.</p>
            </div>

            <div className="space-y-2">
              <h3 className="font-bold text-2xl md:text-2xl text-white">Partnership:</h3>
              <p>Building strong, long-term relationships with farmers, suppliers, and clients.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Vision;
